module.exports = __webpack_public_path__ + "static/img/development.111a957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/development.jpg
// module id = PB7u
// module chunks = 1